// extracted by mini-css-extract-plugin
export default {"container":"rC-z","dimension":"sC-z","dimensionLabels":"tC-z"};